import { setRuntimePublicPath } from './runtime-public-path'

setRuntimePublicPath('/newsroom/build/', '/newsroom/build/')
